export default __webpack_public_path__ + "static/media/landin-blockimg7.154fb33d.png";